<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :large="large" :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon
        ><span v-if="edit === false">
          {{ isAT ? "Grupo de iniciativa" : "Grupo de solução" }}</span
        >
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right" sm="2">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Nome"
              name="nome"
              type="text"
              required
              v-model="payload.nome"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Descrição"
              required
              v-model="payload.descricao"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="close">Fechar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cityGroupSolutionAPI } from "@/modules/city/API/CityGroupSolutionAPI";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalInsertAxis",
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    large: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
  },
  data() {
    return {
      payload: {
        municipioId: this.$route.params.id,
        desabilitado: false,
      },
      dialog: false,
    };
  },
  mounted() {
    if (this.object && this.edit === true) {
      this.payload = this.object;
    }
  },
  computed: {
    ...mapGetters(["isFullAdmin", "isAT"]),
  },
  methods: {
    close() {
      this.dialog = false;
      this.payload = {
        municipioId: this.$route.params.id,
        desabilitado: false,
      };
    },
    onConfirm() {
      if (this.edit === true) {
        cityGroupSolutionAPI
          .update(this.payload)
          .then((resp) => {
            this.dialog = false;
            (this.payload = {
              municipioId: this.$route.params.id,
              desabilitado: false,
            }),
              this.$emit("onSave");
          })
          .catch((resp) => {
            this.$notification.error(
              `Erro ao atualizar ${
                this.isAT ? "Grupo de Iniciativa" : "Grupo de Solução"
              }`
            );
          });
      } else {
        cityGroupSolutionAPI
          .create(this.payload)
          .then((resp) => {
            this.dialog = false;
            (this.payload = {
              municipioId: this.$route.params.id,
              desabilitado: false,
            }),
              this.$emit(`onSave`);
          })
          .catch((resp) => {
            this.$notification.error(
              `Erro ao criar ${
                this.isAT ? "Grupo de Iniciativa" : "Grupo de Solução"
              }`
            );
          });
      }
    },
  },
  watch: {
    object(newValue, oldValue) {
      this.payload = newValue;
    },
  },
};
</script>
